/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popNftShards.vue?vue&type=template&id=1f81a4a2&scoped=true"
import script from "./popNftShards.vue?vue&type=script&lang=js"
export * from "./popNftShards.vue?vue&type=script&lang=js"
import style0 from "./popNftShards.vue?vue&type=style&index=0&id=1f81a4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81a4a2",
  null
  
)

export default component.exports